export default {
    /**
     * 
     * @param Object filter {}
     * @param Array preFilter []
     * @param String filterField 
     * @returns Array []
     */
    formToQuery(filter, preFilter=[], filterField='filter') {
        let params = preFilter;

        // Filter
        if (filter) {
            for (let field in filter) {
                let valor = filter[field];
                if(valor || parseInt(valor) === 0) {
                    if (valor instanceof Date) {
                        const date = new Date(valor);
                        params.push(`${filterField}[${field}]=` + date.toJSON().split("T")[0]);
                    } else if (Array.isArray(valor)) {
                        valor.forEach((item) => {
                            params.push(`${filterField}[${field}][]=${item}`);
                        });
                    } else {
                        params.push(`${filterField}[${field}]=${valor}`);
                    }
                }
            }
        }

        return params;
    },
}